import { registerDe } from '../i18n/index.js';

registerDe({
  'client': 'Kundin',
  'sector not on record': 'Branche nicht erfasst',
  'Organisation archived.': 'Organisation archiviert.',
  'Could not archive the organisation.': 'Die Organisation konnte nicht archiviert werden.',
  'No organisation addressed': 'Keine Organisation adressiert',
  'The link did not name an organisation.': 'Der Link nennt keine Organisation.',
  'Loading…': 'Wird geladen…',
  'People': 'Personen',
  'nobody on record here': 'niemand hier erfasst',
  'Day': 'Tag',
  'Ball': 'Ball',
  'no open commitment': 'keine offene Zusage',
  'Deals': 'Geschäfte',
  'face value': 'Nominalwert',
  'no open deal': 'kein offenes Geschäft',
  'Monitors': 'Monitore',
  'the monitors service did not answer': 'der Monitordienst hat nicht geantwortet',
  'counting the monitors…': 'die Monitore werden gezählt…',
  'last run': 'letzter Lauf',
  'never run': 'nie gelaufen',
  'no monitor watches this organisation': 'kein Monitor beobachtet diese Organisation',
  'tier': 'Stufe',
  'best tier among the people here': 'beste Stufe unter den Personen hier',
  // 'Research' alone is the NOUN on the person brief's fourth column; the mast's one accent verb
  // is a verb, so it carries its own context key and the two never overwrite each other.
  'Research‖verb': 'Recherchieren',
  'Queuing…': 'Wird eingereiht…',
  'Send an agent to read the web for this organisation: the raster cells it can cite, the people it meets, the website if the row has none. Everything arrives in Review as a proposal.':
    'Einen Agenten das Web zu dieser Organisation lesen lassen: die Rasterzellen, die er belegen kann, die Personen, denen er begegnet, die Website, falls die Zeile keine hat. Alles erscheint in der Prüfung als Vorschlag.',
  'Research {ref} queued. Everything it can cite arrives in Review as a proposal — cells, people, a website — and nothing is written until you hold it.':
    'Recherche {ref} eingereiht. Alles, was sie belegen kann, erscheint in der Prüfung als Vorschlag — Zellen, Personen, eine Website — und nichts wird geschrieben, bis Sie es übernehmen.',
  'Could not queue the research run.': 'Der Recherchelauf konnte nicht eingereiht werden.',
  'Nothing owed and nothing stale here — the record is quiet.': 'Hier ist nichts fällig und nichts überfällig — der Eintrag ist ruhig.',
  'People here': 'Personen hier',
  'Person': 'Person',
  'Role': 'Rolle',
  'Tier': 'Stufe',
  'Status': 'Status',
  'Open →': 'Öffnen →',
  'Nobody here yet': 'Noch niemand hier',
  'No person is affiliated with this organisation on the record.': 'Für diese Organisation ist keine Person erfasst.',
  'Pipeline →': 'Pipeline →',
  'No open deal': 'Kein offenes Geschäft',
  'No opportunity is open for this organisation.': 'Für diese Organisation ist kein Geschäft offen.',
  'in stage': 'in dieser Phase',
  'Open commitments': 'Offene Zusagen',
  'Nothing owed': 'Nichts fällig',
  'No commitment is open on either side for this organisation.': 'Für diese Organisation ist auf keiner Seite eine Zusage offen.',
  'Signals': 'Signale',
  'a target with a cadence; every run records its outcome': 'ein Ziel mit Taktung; jeder Lauf hält sein Ergebnis fest',
  'The monitors could not be read: {error}': 'Die Monitore konnten nicht gelesen werden: {error}',
  'No monitor watches this organisation. Add one on the Signals page — its website, its careers page, its SHAB publications by UID, news mentions — and its runs and signals appear here.':
    'Kein Monitor beobachtet diese Organisation. Richten Sie einen auf der Signale-Seite ein — Website, Stellenseite, SHAB-Publikationen nach UID, Erwähnungen in den News — und seine Läufe und Signale erscheinen hier.',
  'Kind': 'Art',
  'Target': 'Ziel',
  'Cadence': 'Taktung',
  'Last run': 'Letzter Lauf',
  'Outcome': 'Ergebnis',
  'website': 'Website',
  'careers': 'Stellen',
  'news': 'News',
  'shab': 'SHAB',
  'zefix': 'Zefix',
  'surfe_job': 'Surfe-Wechsel',
  'tender': 'Ausschreibung',
  'budget': 'Budget',
  'linkedin_manual': 'LinkedIn (manuell)',
  'unchanged': 'unverändert',
  'changed': 'verändert',
  'signal': 'Signal',
  'error': 'Fehler',
  'paused': 'pausiert',
  'failed': 'fehlgeschlagen',
  'Archive this organisation?': 'Diese Organisation archivieren?',
  'The organisation stays on the record; it drops out of the active board.': 'Die Organisation bleibt erfasst; sie fällt aus dem aktiven Board.',

  // round 3 — the market tier in the masthead. The tier words themselves and 'not scored' live
  // in MarketPage.de.ts and PeoplePage.de.ts; only the two sentences this page owns are here.
  'fit {f} × timing {ti} × access {a} = {c} — the score below says which rules fired':
    'Passung {f} × Zeitpunkt {ti} × Zugang {a} = {c} — die Bewertung unten nennt die Regeln, die gegriffen haben',
  'the ICP rules have not scored this organisation':
    'die ICP-Regeln haben diese Organisation nicht bewertet',

  // ── round 4: what a merged row and a child row say in the masthead ──
  'merged into': 'zusammengeführt in',
  'on': 'am',
  'part of': 'gehört zu',
  'this row was archived by a held dedupe proposal; it keeps merged_into for good':
    'diese Zeile wurde durch eine übernommene Dublettenentscheidung archiviert; sie behält merged_into dauerhaft',
  'the merge date is not recorded separately; this is the row’s last change':
    'das Zusammenführungsdatum wird nicht gesondert erfasst; dies ist die letzte Änderung der Zeile',
  'This row was merged into {ref}. Run it on the survivor.':
    'Diese Zeile wurde in {ref} zusammengeführt. Führen Sie es an der verbleibenden Zeile aus.',
  'This row was merged away. Run it on the survivor.':
    'Diese Zeile wurde zusammengeführt. Führen Sie es an der verbleibenden Zeile aus.',

  // ── the last research, the units, the tree ──
  'last research': 'letzte Recherche',
  'still running': 'läuft noch',
  'the last time a research run ended on this organisation':
    'als zuletzt ein Recherchelauf auf dieser Organisation geendet hat',
  '{ref} read the web for this organisation and filed what it could cite':
    '{ref} hat das Web zu dieser Organisation gelesen und eingereicht, was sie belegen konnte',
  'in the tree': 'im Baum',
  'in {n} units': 'in {n} Einheiten',
  '{n} direct': '{n} direkt',
  'Units': 'Einheiten',
  'Unit': 'Einheit',
  'departments, sites and programmes under this organisation':
    'Abteilungen, Standorte und Programme unter dieser Organisation',
  'All people in this tree': 'Alle Personen in diesem Baum',
  'New unit': 'Neue Einheit',
  'The tree could not be read: {error}': 'Der Baum konnte nicht gelesen werden: {error}',
  'No unit sits under this organisation. A unit is a department, a site or a programme with its own name — added here, or proposed by a research run that read it on an organigramme.':
    'Unter dieser Organisation liegt keine Einheit. Eine Einheit ist eine Abteilung, ein Standort oder ein Programm mit eigenem Namen — hier erfasst oder von einem Recherchelauf vorgeschlagen, der sie auf einem Organigramm gelesen hat.',
  'Open deals': 'Offene Geschäfte',
  // declared here so the page reads German without PersonPage's catalogue being loaded
  'Next move': 'Nächster Zug',
  'since last touch': 'seit der letzten Berührung',
  'not scored': 'nicht bewertet',
  'Last contact': 'Letzter Kontakt',
  'no interaction on record': 'kein Kontakt erfasst',
  'Name': 'Name',
  '{name} created as a unit of this organisation.': '{name} als Einheit dieser Organisation erstellt.',
  'Could not create the unit.': 'Die Einheit konnte nicht erstellt werden.',
  'The unit is written as an organisation whose parent is {name}. It appears in the Units zone and in this tree’s people.':
    'Die Einheit wird als Organisation geschrieben, deren übergeordnete Zeile {name} ist. Sie erscheint in der Zone Einheiten und bei den Personen dieses Baums.',
}, 'OrganisationPage');
